import { StoreState } from '@/core/models/store.interface';
import { CancelToken } from 'axios';
import { Module } from 'vuex';
import { Squad } from './squad.interface';
import squadService from './squad.service';

export interface SquadState {
   filtered_squads: Array<Squad>;
}

const SquadStore: Module<SquadState, StoreState> = {
   namespaced: true,
   state: {
      filtered_squads: [],
   },
   getters: {},
   mutations: {
      addFilteredSquad(state, squad: Squad) {
         state.filtered_squads.unshift(squad);
      },
      removeFilteredSquad(state, squad_id: number) {
         const INDEX_OF_DELETED_SQUAD = state.filtered_squads.findIndex((filtered_squad) => filtered_squad.id === squad_id);
         state.filtered_squads.splice(INDEX_OF_DELETED_SQUAD, 1);
      },
      replaceSquad(state, squad: Squad) {
         const SQUAD_INDEX = state.filtered_squads.findIndex((x) => x.id == squad.id);
         state.filtered_squads[SQUAD_INDEX] = squad;
      },
   },
   actions: {
      async get(context, { squad_id, cancel_token }: { squad_id: number; cancel_token: CancelToken }) {
         return await squadService.get(squad_id, cancel_token).then((response) => {
            return response;
         });
      },
      async patch(context, { squad_id, path, value }: { squad_id: number; path: string; value: any }) {
         const BODY = [
            {
               op: 'replace',
               path,
               value,
            },
         ];

         return await squadService.patch(squad_id, BODY).then((response) => {
            context.commit('replaceSquad', response);
            return response;
         });
      },
      async delete(context, squad_id: number) {
         const DELETE_RESPONSE = await squadService.delete(squad_id);
         context.commit('removeFilteredSquad', DELETE_RESPONSE.data.squad.id);
         context.commit('board/deleteSquadFromBoard', DELETE_RESPONSE.data.squad.id, { root: true });
      },
      async archiveSquad({ commit, dispatch }, squad: Squad) {
         await dispatch('delete', squad.id);
      },

      async dearchiveSquad({ commit, dispatch }, squad: Squad) {
         await dispatch('restore', squad.id);
      },
      async getById(context, { squad_id }: { squad_id: number }) {
         return await squadService.getById(squad_id);
      },
   },
};

export default SquadStore;
